// extracted by mini-css-extract-plugin
export default {"footerPosts":"nVUcxG","categoriesControls":"PgOClw"};